import Image from 'next/image'
import React from "react";

export default React.forwardRef((props, ref) => <Image alt={props.alt} {...props}  />)
